import { useEffect, useState } from "react";
import api from "../../lib/api";

/**
 * <RelatedSalesOrderField /> — extracted from JobCardDetail.jsx (Wave
 * 25.16 Phase 2 refactor). Sales-order picker — like RelatedTicketField
 * but for sales documents (category=sales_order). Always scoped to the
 * current customer. Free-text fallback is preserved so a manager can
 * type an external SO ref that hasn't been uploaded yet.
 */
export default function RelatedSalesOrderField({ job, customer, canEdit, onChange }) {
  const [orders, setOrders] = useState([]);
  const value = job.related_sales_order || "";
  useEffect(() => {
    if (!customer?.id) {
      setOrders([]);
      return;
    }
    api
      .get(`/sales-documents?customer_id=${customer.id}&category=sales_order`)
      .then(({ data }) => setOrders(data || []))
      .catch(() => setOrders([]));
  }, [customer?.id]);

  if (!canEdit) {
    return <div className="hv-input mt-1 opacity-70">{value || "—"}</div>;
  }
  // Match against the picker by id, document_number or title.
  const matchedById = orders.find((o) => o.id === value);
  return (
    <div className="space-y-1.5">
      <select
        value={matchedById ? value : ""}
        onChange={(e) => onChange(e.target.value)}
        className="hv-input mt-1"
        data-testid="job-related-sales-order-select"
      >
        <option value="">— Pick an existing sales order —</option>
        {orders.map((o) => (
          <option key={o.id} value={o.id}>
            {o.document_number ? `${o.document_number} · ` : ""}{o.title}
            {o.status ? ` (${o.status})` : ""}
          </option>
        ))}
      </select>
      <input
        value={matchedById ? "" : value}
        onChange={(e) => onChange(e.target.value)}
        className="hv-input text-xs"
        placeholder="…or type an external SO ref (e.g. SO-2026-0123)"
        data-testid="job-related-sales-order-text"
      />
    </div>
  );
}
